export default "__VITE_ASSET__CBN3n__h__"